import ApiService from '../service/ApiService';
import ApiServiceAxios from '../service/ApiServiceAxios';
import MethodService from '../service/MethodService';

let moduleApi = {};
let moduleName = "chat_rooms";
let token = MethodService.getToken();
let hostApi831PHR = window.MyConfig.hostApi831PHR;
moduleApi.create = (dataForm) => {
    let api = {
        module: moduleName,
        type: "create",
        value: dataForm
    };
    return ApiService(api);
};

moduleApi.update = (dataForm) => {
    let api = {
        module: moduleName,
        type: "partialUpdate",
        value: dataForm
    };
    return ApiService(api);
};

moduleApi.list = (dataFilter) => {
    let api = {
        module: moduleName,
        type: "list",
        value: dataFilter
    };
    return ApiService(api);
};


moduleApi.delete = (id) => {
    let api = {
        module: moduleName,
        type: "delete",
        value: { id: id }
    };
    return ApiService(api);
};


moduleApi.findById = (id) => {
    let api = {
        module: moduleName,
        type: "findById",
        value: { id: id }
    };
    return ApiService(api);
};

moduleApi.getDMICD10 = async (ma_nhom, tokenTichHop) => {
    console.log("TokenTichHop", tokenTichHop);
    // const objJsonB64 = Buffer.from(JSON.stringify(body)).toString('base64');OPLcBn5fSsl7QzNy7QUHf9KKQ+s0MsaGTiSxbsqrNW8=
    // let url = `http://ehrc.vietsens.vn:4567/api/PHR/LoadDMICD10ByMA_NHOM?token=7ba7267da7a2e677a00ef534f7e93e432d355f4521d94301e5cb9bb60b812977&ApplicationCode=${window.MyConfig.applicationCode831}&MA_NHOM=${ma_nhom}`
    let url = `${hostApi831PHR}LoadDMICD10ByMA_NHOM?token=${tokenTichHop}&ApplicationCode=${window.MyConfig.applicationCode831}&MA_NHOM=${ma_nhom}`
    let api = {
        method: "GET",
        url: url,
        headers: {},
        message: {
            success: "",
            error: "",
        },
    };
    return ApiServiceAxios(api);
}
export default moduleApi;
